module.exports = __webpack_public_path__ + "img/4-2.f2e1f85a.svg";